module.exports = __webpack_public_path__ + "img/unknown.e91b49b7.svg";